import { http, HttpHandler, HttpResponse, type RequestHandler } from 'msw'
import { getApiRoute } from '@core/utils/api'

import {
  postUserPasswordResetRequestConfig,
  postUserPasswordResetValidateConfig,
  postUserPasswordResetConfirmConfig,
  getUserProfileConfig,
  postUserRegisterConfig,
  postConfirmEmailConfig,
  postValidateEmailConfig,
  postCreateProfileConfig,
} from '@services/User/api'

import { profileMock, postCreateProfileMock, postCreateProfileErrorUserMock } from '@services/User/mocks'

export const postUserPasswordResetRequestHandler: RequestHandler = http.post(
  getApiRoute(postUserPasswordResetRequestConfig.url),
  () => HttpResponse.json(),
)

export const postPasswordResetValidateHandler: RequestHandler = http.post(
  getApiRoute(postUserPasswordResetValidateConfig.url),
  () => HttpResponse.json(),
)

export const postPasswordResetConfirmHandler: RequestHandler = http.post(
  getApiRoute(postUserPasswordResetConfirmConfig.url),
  () => HttpResponse.json({ token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhIjoiMSJ9.5Rv5OyU0_KC_hfRuIQWxZP4UauRa8UHJai8rztkCFLc', token_ttl: 180 }),
)

export const postPasswordResetConfirmHandlerErrorInvalidCode: RequestHandler = http.post(
  getApiRoute(postUserPasswordResetConfirmConfig.url),
  () => HttpResponse.json({ error: { detail: 'Invalid code', status: 400 } }, { status: 400 }),
)

export const getUserProfileHandler: HttpHandler = http.get(
  getApiRoute(getUserProfileConfig.url),
  () => HttpResponse.json(profileMock),
)

export const postUserRegisterHandler: RequestHandler = http.post(
  getApiRoute(postUserRegisterConfig.url),
  () => HttpResponse.json(),
)

export const postUserEmailConfirmationHandler: HttpHandler = http.post(
  getApiRoute(postConfirmEmailConfig.url),
  () => HttpResponse.json(),
)

export const postValidateEmailHandler: HttpHandler = http.post(
  getApiRoute(postValidateEmailConfig.url),
  () => HttpResponse.json(),
)

export const postCreateProfileHandler: RequestHandler = http.post(
  getApiRoute<{ profileType: string }>(
    postCreateProfileConfig.url,
    { params: { profileType: ':profileType' } },
  ),
  () => HttpResponse.json(postCreateProfileMock),
)

export const postCreateProfileHandlerErrorUser: RequestHandler = http.post(
  getApiRoute<{ profileType: string }>(
    postCreateProfileConfig.url,
    { params: { profileType: ':profileType' } },
  ),
  () => HttpResponse.json(postCreateProfileErrorUserMock, { status: 400 }),
)

export default [
  postUserPasswordResetRequestHandler,
  postPasswordResetValidateHandler,
  postPasswordResetConfirmHandler,
  getUserProfileHandler,
  postUserRegisterHandler,
  postCreateProfileHandler,
  postCreateProfileHandlerErrorUser,
]
